import { IconButton, styled } from "@mui/material";

//region [[ Styles ]]

export const LineActions = styled("div")(({ theme }) => ({
  display: "flex",
  gap: 0,
  background: "#FFFFFF",
  borderRadius: 8,
  padding: "5px 8px",
  boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.1)",
  marginLeft: "auto",
  height: 40,
  alignSelf: "flex-end",
  alignItems: "center",
  "&.active": {
    background: theme.palette.secondary.light,
  },
  "&:dir(rtl)": {
    marginLeft: "0",
    marginRight: "auto",
  },
}));

export const LineActionsButton = styled(IconButton)(({ theme }) => ({
  border: "none",
  background: "transparent",
  borderRadius: 6,
  padding: "4px 6px",
  color: "inherit",
  cursor: "pointer",
  "& svg": {
    height: 15,
    width: 15,
  },
  "&.active svg": {
    fill: theme.palette.primary.main,
  },
}));
